import { render, staticRenderFns } from "./migrateProduct.vue?vue&type=template&id=06ff10a6&scoped=true&"
import script from "./migrateProduct.vue?vue&type=script&lang=js&"
export * from "./migrateProduct.vue?vue&type=script&lang=js&"
import style0 from "./migrateProduct.vue?vue&type=style&index=0&id=06ff10a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff10a6",
  null
  
)

export default component.exports